// @flow
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import PrintGoalcard from 'components/shared/PrintGoalcard/index';
import PopUpShowerQR from 'components/shared/PopUpShowerQR/PopUpShowerQR';
import Animation from './Animation';

// type Props = {
//   changePassword: (hash: string, newPassword: string) => Promise<any>,
//   ...
// }

const GoalcardAnimatedPage = (props: Props) => {
  const browserHistory = useHistory();

  const [showDownloadPopUp, setShowDownloadPopUp] = useState(false);

  const componentRef = useRef();

  const { t } = useTranslation();

  const onPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const onClaim = () => {
    if (isMobile) {
      window.location = props.goalcard.claimURL;
    } else {
      setShowDownloadPopUp(true);
    }
  };

  useEffect(() => {
    if (!props.goalcard) {
      browserHistory.goBack();
    }
  }, []);

  if (!props.goalcard) {
    return null;
  }

  return (
    <>
      <Animation onPrint={onPrint} onClaim={onClaim} goalcard={props.goalcard} isFromAffiliateFlow={props.isFromAffiliateFlow} />

      <div style={{ display: 'none' }}>
        <div ref={componentRef}>
          <PrintGoalcard goalcard={props.goalcard} />
        </div>
      </div>

      <PopUpShowerQR
        show={showDownloadPopUp}
        hasCloseBtn
        onClose={() => setShowDownloadPopUp(false)}
        qrContent={props.goalcard.claimURL}
      />
    </>
  );
};

// Map Props
const mapStateToProps = (state) => ({
  goalcard: state.viewGoalcard.goalcard,
  isFromAffiliateFlow: state.viewGoalcard.isFromAffiliate,
});

export default connect(
  mapStateToProps,
)(GoalcardAnimatedPage);
